import React, { FC, ReactElement } from 'react';
import AllRoutes from './AllRoutes';

const Component: FC = (): ReactElement => {
	return <AllRoutes />;
};

export default Component;
